import React from "react";
import { useTV } from "../../../hooks/useTV";
import useGlobalStore from "../../../store/global.store";
import MultiViewLandingDisplay from "./MultiViewLandingDisplay/MultiViewLandingDisplay";
import MultiViewLandingTV from "./MultiViewLandingTV/MultiViewLandingTV";
import BeaconMultiViewDisplay from "./BeaconMultiViewDisplay/BeaconMultiViewDisplay";
import BeaconMultiViewTV from "./BeaconMultiViewTV/BeaconMultiViewTV";
import VipSubCheck from "../VIP/VipSubCheck";
import BeaconSubCheck from "../MagicBand/BeaconSubCheck";

const MultiViewLanding = () => {
  const { isTv } = useTV();
  const hasBeaconAddOn = useGlobalStore((state) => state.hasBeaconAddOn);

  // Beacon add-on customers get the new Magic Beacon multiview (HLS sync,
  // peer handoff, doors, cue runner — built progressively in checkpoints 2+).
  // Non-Beacon customers get the existing multiview unchanged.
  if (hasBeaconAddOn) {
    return (
      <>
        {isTv ? <BeaconMultiViewTV /> : <BeaconMultiViewDisplay />}
        <VipSubCheck />
        <BeaconSubCheck />
      </>
    );
  }

  return (
    <>
      {isTv ? <MultiViewLandingTV /> : <MultiViewLandingDisplay />}
      <VipSubCheck />
    </>
  );
};

export default MultiViewLanding;
